import { useLayoutEffect } from "react"
import { useLocation, useOutletContext } from "react-router-dom"
import { usePage } from "contexts/page-context"
import { Transition } from "components"
import Form from "./form"

export default function Create() {
  const { setTransition } = usePage()
  const { setTitle } = useOutletContext()
  const location = useLocation()

  useLayoutEffect(() => {
    setTransition(location.state?.transition)
    setTitle("Order HO ke Customer")
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Transition type="fade">
      <Form />
    </Transition>
  )
}
